// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","container":"Message__container--AV","info":"Message__info--BH","infoIcon":"Message__infoIcon--rW","warningIcon":"Message__warningIcon--Vd"};